<template>
  	<div class="module_page page_content institution" aria-label="Institution Summary view content page">
  
    <div class="row page-heading">
      <div class="col-7 input module_heading" role="heading" aria-level="1">
        <span class="module_icon ic-inst"></span>
        <label class="head_txt module_type_name institution-title ace_sec_hd">{{institution.displayName}}</label>
        <!-- <label class="head_txt module_type_name institution-title ace_sec_hd"><span v-if="advisorTitle">{{advisorTitle}}: </span>{{institution.title}}</label>
        <label class="head_txt module_type_name ace_sec_hd" v-if="showEntity"> <span class="separator">::</span> {{entity.title}}</label> -->
      </div>
      <div class="col-5 right-container">
      </div>
    </div>
    
	    <div class="page_content_container">
	      	<institution-menu :uuid="uuid" :active="'summary'"></institution-menu>
	      
		      <div class="row pg_content">
			      <div class="col-12">
			          <b-jumbotron>
			            <h4 class="text-center ace_sec_txt">Summary View is currently not available.</h4>
			            <p class="text-center ace_sec_txt">Please reach out to your institutional admin to unlock the Summary View.</p>
			          </b-jumbotron>
			      </div>
		      </div>
	    </div>
    
	</div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import InstitutionMenu from './InstitutionMenu'
import InstitutionHeader from './InstitutionHeader'

export default {
  name: 'institutionSummary',
  props: ['uuid'],
  components: {
    InstitutionMenu,
    InstitutionHeader
  },
  data: () => {
    return {
      uObj: JSON.parse(localStorage.getItem('userobj')),
      userrole: localStorage.getItem('userrole')
    }
  },
  mounted () {
    this.loadInstitution()
  },
  methods: {
    ...mapActions([
      'loadInstitutionDetail',
      'loadUserAdvisor',
      'loadLogDashboardActivity'
    ]),

    loadInstitution () {
      this.loadLogDashboardActivity({action: 'viewInstitutionSummaryView', page: 'institutionSummaryView', link: '', entityUuid: this.uuid})
      this.loadInstitutionDetail(this.uuid)
    }
  },
  computed: {
    ...mapState({
      'institution': state => state.institution.institution
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/app/institution/components/InstitutionSummary.vue